import { createActions } from 'redux-actions';
import {
  createAlert,
  createSuccessAlert,
} from './ActionCreators';

import ActionFactory from './ActionFactory';
import {
  FPP,
  GET_FPP_RECORD_LIST,
  GET_FPP_MAIN_QUESTIONS,
  GET_FPP_RECOMMENDATION,
  SUBMIT_FPP_ADDITIONAL_QUESTIONS,
  GET_SUBMITTED_SURVEY_DETAIL,
  GET_ASSESSMENT_PDF,
  GET_ASSESSMENT_HISTORY_PDF,
  CHECK_EXPORT_PDF_PERMISSION,
} from '../constants/ActionTypes';
import FPPAPIConnectors from '../api/FPPAPIConnectors';
import i18n from '../config/i18n';

const plainActions = createActions(
  ...Object.values(ActionFactory(GET_FPP_RECORD_LIST)),
  ...Object.values(ActionFactory(GET_FPP_MAIN_QUESTIONS)),
  ...Object.values(ActionFactory(GET_FPP_RECOMMENDATION)),
  ...Object.values(ActionFactory(SUBMIT_FPP_ADDITIONAL_QUESTIONS)),
  ...Object.values(ActionFactory(GET_SUBMITTED_SURVEY_DETAIL)),
  ...Object.values(ActionFactory(GET_ASSESSMENT_PDF)),
  ...Object.values(ActionFactory(GET_ASSESSMENT_HISTORY_PDF)),
  ...Object.values(ActionFactory(CHECK_EXPORT_PDF_PERMISSION)),
  { prefix: FPP },
);

const thunkActions = {
  getFPPRecords: medicalRecordId => (
    async (dispatch) => {
      try {
        dispatch(plainActions.getFppRecordListRequest());
        const result = await FPPAPIConnectors.getUserSurveyRecords(medicalRecordId);
        dispatch(plainActions.getFppRecordListSuccess(result));
        return true;
      } catch (err) {
        dispatch(plainActions.getFppRecordListFailure(err));
      }
      return false;
    }
  ),
  getFPPMainQuestions: () => (
    async (dispatch) => {
      try {
        dispatch(plainActions.getFppMainQuestionsRequest());
        const result = await FPPAPIConnectors.getFPPSurvey();
        dispatch(plainActions.getFppMainQuestionsSuccess(result));
        return result;
      } catch (err) {
        dispatch(plainActions.getFppMainQuestionsFailure(err));
      }
      return false;
    }
  ),
  getRecommendation: answers => (
    async (dispatch) => {
      try {
        dispatch(plainActions.getFppRecommendationRequest());
        const result = await FPPAPIConnectors.getRecommendation(answers);
        dispatch(plainActions.getFppRecommendationSuccess(result));
        return result;
      } catch (err) {
        dispatch(plainActions.getFppRecommendationFailure(err));
        dispatch(createAlert(err));
      }
      return false;
    }
  ),
  submitAdditionalQuestions: (answers, additionalQuestionsSubmissionId) => (
    async (dispatch) => {
      try {
        dispatch(plainActions.submitFppAdditionalQuestionsRequest());
        const result = await FPPAPIConnectors.submitAdditionalQuestions(
          answers,
          additionalQuestionsSubmissionId
        );
        dispatch(plainActions.submitFppAdditionalQuestionsSuccess(result));
        return result;
      } catch (err) {
        dispatch(plainActions.submitFppAdditionalQuestionsFailure(err));
      }
      return false;
    }
  ),
  getSubmittedSurveyDetail: assessmentId => (
    async (dispatch) => {
      try {
        dispatch(plainActions.getSubmittedSurveyDetailRequest());
        const result = await FPPAPIConnectors.getSubmittedSurveyDetail(assessmentId);
        dispatch(plainActions.getSubmittedSurveyDetailSuccess(result));
        return result;
      } catch (err) {
        dispatch(plainActions.getSubmittedSurveyDetailFailure(err));
      }
      return false;
    }
  ),
  getAssessmentPDF: userSurveyId => (
    async (dispatch) => {
      try {
        dispatch(plainActions.getAssessmentPdfRequest());
        await FPPAPIConnectors.getAssessmentPDF(userSurveyId);
        dispatch(plainActions.getAssessmentPdfSuccess());
        dispatch(createSuccessAlert(i18n.t('downloadPdf')));
        return true;
      } catch (err) {
        dispatch(plainActions.getAssessmentPdfFailure());
        dispatch(createAlert(err));
      }
      return false;
    }
  ),
  getAssessmentHistoryPDF: userSurveyId => (
    async (dispatch) => {
      try {
        dispatch(plainActions.getAssessmentHistoryPdfRequest());
        await FPPAPIConnectors.getAssessmentHistoryPDF(userSurveyId);
        dispatch(plainActions.getAssessmentHistoryPdfSuccess());
        dispatch(createSuccessAlert(i18n.t('downloadPdf')));
        return true;
      } catch (err) {
        dispatch(plainActions.getAssessmentHistoryPdfFailure());
        dispatch(createAlert(err));
      }
      return false;
    }
  ),
  checkExportPDFPermission: () => (
    async (dispatch) => {
      try {
        dispatch(plainActions.checkExportPdfPermissionRequest());
        await FPPAPIConnectors.checkExportPDFPermission();
        dispatch(plainActions.checkExportPdfPermissionSuccess());
        return true;
      } catch (err) {
        dispatch(plainActions.checkExportPdfPermissionFailure(err));
        dispatch(createAlert(err));
      }
      return false;
    }
  ),
};

export default {
  ...plainActions,
  ...thunkActions,
};



// WEBPACK FOOTER //
// ./src/actions/FPPActionCreators.js